import { useQuery } from '@tanstack/react-query';
import { complimentaryService } from '../services/complimentary.service';

export const useComplimentaryServices = (category = null) => {
  return useQuery({
    queryKey: ['complimentary-services', category],
    queryFn: async () => {
      const response = await complimentaryService.getComplimentaryServices(category);
      return response;
    },
    enabled: true,
  });
};

export const useComplimentaryServiceById = (id) => {
  return useQuery({
    queryKey: ['complimentary-service', id],
    queryFn: async () => {
      const response = await complimentaryService.getComplimentaryServiceById(id);
      return response;
    },
    enabled: !!id,
  });
};
